import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueTypeScreenSchemesDescription: {
		id: 'admin-pages-issue-type-screen-schemes-page.page-description.issue-type-screen-schemes-description',
		defaultMessage:
			'An Issue Type Screen Scheme allows you to choose what {screenSchemeLink} is used for each issue type. Then, an Issue Type Screen Scheme can be associated with one or more projects, to specify what Screen Scheme, and hence what {screenLink} should be used for a particular issue operation for the projects issues.',
		description: 'Description for screen schemes page',
	},
	issueTypeScreenSchemesNote: {
		id: 'admin-pages-issue-type-screen-schemes-page.page-description.issue-type-screen-schemes-note',
		defaultMessage:
			'Note: It is not possible to delete an Issue Type Screen Scheme, if it is associated with at least one project.',
		description: 'Description for issue type screen schemes page',
	},
	screenScheme: {
		id: 'admin-pages-issue-type-screen-schemes-page.page-description.screen-scheme',
		defaultMessage: 'Screen Scheme',
		description: 'screen scheme text',
	},
	screen: {
		id: 'admin-pages-issue-type-screen-schemes-page.page-description.screen',
		defaultMessage: 'Screen',
		description: 'screen text',
	},
});
